import React from 'react';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  variant?: 'danger' | 'default';
}
export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  variant = 'danger'
}: ConfirmDialogProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm p-4" data-id="element-1216">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl border border-[#E8E8ED] animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-1217">
        <div className="p-6" data-id="element-1218">
          {/* Icon + Title */}
          <div className="flex items-start gap-4" data-id="element-1219">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${variant === 'danger' ? 'bg-[#E34402]/10' : 'bg-[#FC4C02]/10'}`} data-id="element-1220">
              <AlertTriangleIcon className={`h-5 w-5 ${variant === 'danger' ? 'text-[#E34402]' : 'text-[#FC4C02]'}`} data-id="element-1221" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1222">
              <h3 className="text-base font-semibold text-[#2D2D2D]" data-id="element-1223">
                {title}
              </h3>
              <p className="text-sm text-[#6B6B76] mt-1.5 leading-relaxed" data-id="element-1224">
                {message}
              </p>
            </div>
            <button onClick={onClose} className="text-[#9B9BA7] hover:text-[#2D2D2D] p-1 rounded-lg hover:bg-[#F7F7FA] transition-colors flex-shrink-0 -mt-1 -mr-1" data-id="element-1225">
              <XIcon className="h-4 w-4" data-id="element-1226" />
            </button>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2.5 mt-6" data-id="element-1227">
            <button onClick={onClose} className="h-9 px-4 rounded-xl border border-[#E8E8ED] bg-white text-sm font-semibold text-[#6B6B76] hover:bg-[#F7F7FA] transition-colors" data-id="element-1228">
              {cancelLabel}
            </button>
            <button onClick={() => {
            onConfirm();
            onClose();
          }} className={`h-9 px-4 rounded-xl text-sm font-semibold text-white transition-colors ${variant === 'danger' ? 'bg-[#E34402] hover:bg-[#C93D00]' : 'bg-[#FC4C02] hover:bg-[#E04400]'}`} data-id="element-1229">
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>;
}